import React from 'react';
import {connect} from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import compose from 'recompose/compose';
import * as ResourceApi from "api/resources";
import {getAllResourcesAction} from "resources/actions";
import {filterOptionsFactory, sortOptionsFactory} from "viewOptions/factories";
import UserTagDropdown from 'components/forms/CustomFields/UserTagDropdown';
import {createResourceTypeSelector} from "resources/selectors";

const getAllUserTags = createResourceTypeSelector(ResourceApi.Types.Tag);

const mapStateToProps = (state) => ({
    userTags: getAllUserTags(state.resources)
});

const mapDispatchToProps = (dispatch) => ({
    getUserTags: () => dispatch(getAllResourcesAction(ResourceApi.Types.Tag, sortOptionsFactory(), filterOptionsFactory()))
});

const UserTagDropdownConnected = connect(mapStateToProps, mapDispatchToProps);

const UserTagDropdownLifecycle = lifecycle({
    componentDidMount: function() {
        this.props.getUserTags();
    }
});

const UserTagDropdownComposed = compose(
    UserTagDropdownConnected,
    UserTagDropdownLifecycle
)(UserTagDropdown);

export default UserTagDropdownComposed;



// WEBPACK FOOTER //
// ./public/components/composites/UserTagDropdownConnected.jsx